type SalonpageImage = {
  id: string;
  kind: string;
};

export function salonpageImageGroups<T extends SalonpageImage>(images: T[]) {
  const featureImages = images.filter((image) => image.kind === "feature");
  const dedicatedAtmosphereImages = images.filter(
    (image) =>
      image.kind === "atmosphere" || image.id.includes("-feature-atmosphere-"),
  );
  const hasDedicatedAtmosphereImages = dedicatedAtmosphereImages.length > 0;

  return {
    atmosphereImages: hasDedicatedAtmosphereImages
      ? dedicatedAtmosphereImages
      : featureImages,
    kodawariImages: hasDedicatedAtmosphereImages
      ? featureImages
          .filter((image) => !dedicatedAtmosphereImages.includes(image))
          .slice(0, 6)
      : featureImages.slice(3, 9),
  };
}

export function salonpagePrimaryImage<T extends SalonpageImage>(images: T[]) {
  const heroImage = images.find((image) => image.kind === "hero");
  if (heroImage) return heroImage;

  return salonpageImageGroups(images).atmosphereImages[0];
}
